module.exports = __webpack_public_path__ + "img/my-sisley-club-title.0a77ddca.svg";